
import find from 'lodash/find';
import ShapeProductsResponse from '../../shared/ShapeProductsResponse';

const getters = {
  pricingPlans: state => state.pricingPlans,
  pricingPlansLoaded: state => state.pricingPlansLoaded,
  selectedPlan: state => state.selectedPlan,
  trialPeriodDays: (state) => {
    if (state.selectPricingPlan && state.selectPricingPlan.trialPeriodDays) {
      return state.selectPricingPlan.trialPeriodDays;
    }
    return 7;
  },
  marketingPrice: (state) => {
    if (state.pricingPlansLoaded) {
      return find(state.pricingPlans, { planTypeString: 'monthly' }, { price: 4.99 });
    }
    return { price: 4.99 };
  },
  freePlanSelected: state => state.freePlanSelected,
};

const mutations = {
  setPricingPlans: (state, pricingPlans) => { state.pricingPlans = pricingPlans; },
  setpricingPlansLoaded: (state, pricingPlansLoaded) => { state.pricingPlansLoaded = pricingPlansLoaded; },
  selectPricingPlan: (state, plan) => { state.selectedPlan = plan; },
  selectFreePlan: (state) => { state.freePlanSelected = true; },
  deselectFreePlan: (state) => { state.freePlanSelected = false; },
};

const state = {
  pricingPlans: {
    monthly: {
      currency: 'USD',
      price: 7.99,
      id: null,
    },
    annual: {
      currency: 'USD',
      price: 49.99,
      id: null,
    },
  },
  pricingPlansLoaded: false,
  selectedPlan: null,
  freePlanSelected: false,
};

const actions = {
  setPricingPlans: (context, { response, currencyCode }) => {
    const dataShaper = new ShapeProductsResponse();
    const pricingPlans = dataShaper.getPricingPlans({ response, currencyCode });
    context.commit('setPricingPlans', pricingPlans);
    context.commit('setpricingPlansLoaded', true);
  },
  selectPricingPlan: (context, plan) => {
    context.commit('selectPricingPlan', plan);
  },
  selectFreePlan: (context) => {
    context.commit('selectFreePlan');
  },
  deselectFreePlan: (context) => {
    context.commit('deselectFreePlan');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
